<template>
  <div class="mask" v-if="dataVal.flag">
      <div class="mask-content">
          <div class="mask-content-header">
              <div>{{ dataVal.title }}</div>
              <div @click="handleRefund">
                  <el-icon name="close" size="16"></el-icon>
              </div>
          </div>
          <div class="mask-content-body">
              <div class="mask-content-body-select">
                  <div class="mask-content-body-select-title">参数名称<span>*</span>：</div>
                  <div class="mask-content-body-select-input">
                      <el-input v-model="form.name" clearable placeholder="请输入参数名称"></el-input>
                  </div>
              </div>
              <div class="mask-content-footer">
                  <div @click="handleRefund">取消</div>
                  <div @click="handleSubmit">确定</div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "AddGroup",
  props: ['dataVal'],
  data() {
      return {
          form: {
              name: '',
          }
      };
  },
  mounted() {
  },
  methods: {
      //取消弹窗
      handleRefund() {
          let data = {
              flag: false,
              submitFlag: false,

          }
          this.$emit("transferNannyCell", data);
      },
      handleSubmit() {
          let data = {
              flag: false,//弹窗是否显示
              submitFlag: true,//是否调用接口
              name:this.form.name,//参数名称
          }
          this.$emit("transferNannyCell", data);
      },
  },
  watch: {
      dataVal: {
          handler(newVal, oldVal) {
              if (newVal.flag) {
                  
                  if (newVal.edit == 1) {
                    this.form.name = newVal.content;
                  }else {
                    this.form.name = "";
                  }
              }
          },
          deep: true
      },
  }
};
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;

  .mask-content {
      width: 715px;
      border-radius: 10px;
      background: #FFF;
      overflow: hidden;
      position: fixed;

      .mask-content-header {
          width: 100%;
          min-height: 50px;
          background: #C12E30;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 20px;

          div {
              color: var(--Gray-White, #FFF);
              font-size: 16px;
          }

          .el-icon-close {
              color: #FFF;
          }
      }

      .mask-content-body {
          width: 100%;
          background-color: #FFF;
          padding: 20px 20px 34px 20px;

          .mask-content-body-select {
              width: 100%;
              display: flex;
              align-items: center;
              margin-bottom: 20px;

              .mask-content-body-select-title {
                  width: 87px;
                  color: #A6A6A6;
                  font-size: 14px;
                  display: flex;
                  align-items: center;

                  span {
                      color: #C12E30;
                  }
              }

              /deep/ .mask-content-body-select-input {
                  flex: 1;
                  display: flex;
                  align-items: center;

                  .el-select {
                      flex: 1;
                  }

                  .el-date-editor {
                      flex: 1;
                  }

                  .mask-content-body-select-input-span {
                      width: 30px;
                      color: #A6A6A6;
                      font-size: 14px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                  }

                  .avatar-uploader {
                      .el-upload {
                          border: 1px dashed #DCDCDC;
                          background: #E7E7E7;
                      }
                  }

                  .el-upload__tip {
                      width: 100%;
                      height: 100%;
                      flex-direction: column;
                      @include flex-center(center, center);

                      .avatar-uploader-text {
                          color: rgba(0, 0, 0, 0.40);
                          font-size: 12px;
                          line-height: normal;
                          margin-top: 10px;
                      }
                  }

                  .upload-demo {
                      width: 100%;

                      .el-upload {
                          width: 100%;

                          .el-upload-dragger {
                              width: 100%;
                              height: 50px;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                          }
                      }
                  }
              }
          }

          .mask-content-body-select2 {
              display: flex;
              align-items: normal;

              .mask-content-body-select-title {
                  align-items: normal;
                  line-height: 40px;
              }
          }

          .mask-content-footer {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              margin-top: 227px;

              div {
                  width: 120px;
                  height: 40px;
                  color: rgba(0, 0, 0, 0.90);
                  font-size: 14px;
                  border-radius: 5px 0 0 5px;
                  background: #EDC2C3;
                  @include flex-center(center, center);
                  cursor: pointer;

                  &:nth-child(2) {
                      border-radius: 0 5px 5px 0;
                      color: rgba(255, 255, 255, 0.90);
                      background: #B30003;
                  }
              }
          }
      }
  }
}

.el-date-picker {
  z-index: 9999 !important;
}
</style>